import { CircularProgress, useTheme } from '@mui/material';
import { Skeleton } from '@mui/material';

const Loading = (props) => {
  const { type = 'DEFAULT', disableAnimation } = props;
  const theme = useTheme();

  const SKELETONS = {
    DEFAULT: (
      <div
        className="row align-center justify-center width-max height-max"
        data-testid="loading-id"
      >
        <CircularProgress size={theme.spacing(10)} />
      </div>
    ),
    COMMENTS: (
      <div className="row gap">
        <Skeleton
          variant="circular"
          sx={{ minWidth: '42px', height: '42px' }}
          animation={disableAnimation}
        />
        <div className="col gap-sm width-max">
          <Skeleton width={120} animation={disableAnimation} />
          <Skeleton variant="rounded" height={50} animation={disableAnimation} />
        </div>
      </div>
    ),
  };

  return SKELETONS[type];
};

export default Loading;
